<router-outlet></router-outlet>
<nearby-map></nearby-map>